<template>
  <moe-page>
    <moe-top></moe-top>
    <div class="coupon_box flex Flexjustify Flexalign">
      <div class="coupon_content">
        <div class="menu_list flex">
          <div class="menu_one flex flexcolumn Flexalign cursor_pointer" v-for="(item, index) in menuList" :key="index"
            @click="chaneMenu(item)" :class="{ active_menu: selectMenu == item.value }">
            {{ item.label }}
          </div>
        </div>
        <div class="coupon_list FlexWrap flex" v-if="couponList.length">
          <div class="coupon_one flex" :class="(index%3==0?'':'ml-20')" v-for="(item, index) in couponList" :key="index">
            <div class="coupon_one_left flex Flexjustify FlexBaseline" :class="[item.state != 0 ? 'bg_gray' : '']">
              <div v-if="item.couponType==1" class="flex Flexalign toverflow" style="flex-shrink: initial;"><div>￥</div><div class="coupon_discount toverflow flex-1">{{ item.reduceMoney }}</div></div>
              <div v-else class="toverflow">{{ item.reduceMoney }}折</div>
            </div>
            <div class="coupon_one_right flex-1 flex flexcolumn FlexAround"
              :class="[item.state != 0 ? 'bg_gray' : '']">
              <div class="coupon_name">{{ item.couponName }}</div>
              <div class="flex FlexBetween Flexalign coupon_condition">
                <div>{{ item.couponType==1?`满${item.fullMoney || 0}元减${item.reduceMoney}元`:`${item.reduceMoney}折` }}</div>
                <div class="btn_use cursor_pointer mt-10" :class="[item.state != 0 ? 'btn_gray' : '']" @click="goUse(item)">
                  {{
                    item.state == 0
                      ? "去使用"
                      : (item.state == 1
                        ? "已使用"
                        : "已过期")
                  }}
                </div>
              </div>
              <div class="coupon_condition toverflow">适用于：{{ item.shopName }}</div>
              <div class="coupon_condition">截止日期：{{ item.endTime || "永久" }}</div>
            </div>
          </div>
          <div class="pagination_box mar_top_10 flex FlexjustifyEnd" style="width: 100%;">
            <el-pagination background layout="prev, pager, next" :total="listTotal"
              @current-change="handleCurrentChange" />
          </div>
        </div>
        <div v-else>
          <moe-empty url="moe_empty_bg_img.png" emptyText="暂无优惠券"></moe-empty>
        </div>
      </div>
    </div>
  </moe-page>
</template>

<script>
export default {
  name: "GjkcH5Coupon",

  data() {
    return {
      menuList: [
        { label: "未使用", value: 0 },
        { label: "已使用", value: 1 },
        { label: "已过期", value: 2 },
      ],
      selectMenu: 0,
      couponList: [],
      listQuery: {
        page: 1,
        pageSize: 9,
        shopId: '',
        applyType: 4,
        state: 0, // 0 已领取  1 已使用  2 已过期
      },
      listTotal: 0
    };
  },

  mounted() { 
    this.getCouponList();
  },

  methods: {
    chaneMenu(info) {
      this.selectMenu = info.value;
      this.listQuery.state = info.value;
      this.getCouponList();
    },
    handleCurrentChange(value) {
      this.listQuery.page = value;
      this.getCouponList();
    },
    getCouponList() {
      this.$Api.shop.getCouponList(this.listQuery).then(res => {
        this.listTotal = res.data.data.total ? Number(res.data.data.total) : 0;
        this.couponList = res.data.data.list;
      }).catch(() => { })
    },
    goUse(info){
      if(info.state != 0) return
      this.$Jump.href("/courseList")
    }
  },
};
</script>
<style lang="scss" scoped>
.coupon_box {
  width: 100%;
  min-height: calc(100vh - $pageTopHeight);
  background: #f3f3f3;

  .coupon_content {
    margin-top: 20px;
    box-sizing: border-box;
    width: $pageMainWidth;
    min-height: 966px;
    background: #ffffff;
    border-radius: 10px;
    padding: 20px;

    .menu_list {
      border-bottom: 1px solid rgba(20, 20, 20, 0.1);

      .menu_one {
        line-height: 50px;
        margin-right: 20px;
        font-weight: bold;
        font-size: 18px;
        position: relative;
      }

      .active_menu {
        color: #13d6aa;
      }
    }

    .coupon_list {
      .coupon_one {
        margin-top: 20px;
        width: 368px;
        height: 112px;
        background: #ffffff;
        box-shadow: 0px 0px 9px 0px rgba(0, 0, 0, 0.09);
        border-radius: 10px;

        .coupon_one_left {
          width: 102px;
          height: 112px;
          background: linear-gradient(90deg, #ff8a4c, #fe5e3c);
          border-radius: 10px 0px 0px 10px;
          font-size: 24px;
          line-height: 112px;
          color: #ffffff;

          .coupon_discount {
            font-size: 26px;
            // font-weight: 600;
          }
        }

        .coupon_one_right {
          padding: 0 10px;
          box-sizing: border-box;

          .coupon_name {
            font-size: 18px;
            color: #333333;
          }

          .coupon_condition {
            font-size: 14px;
            color: #999999;
          }

          .btn_use {
            width: 86px;
            height: 36px;
            border-radius: 18px;
            border: 1px solid #ff6619;
            font-size: 16px;
            color: #ff6619;
            text-align: center;
            line-height: 36px;
          }

          .btn_gray {
            width: 86px;
            height: 36px;
            background: #cccccc;
            border-radius: 6px;
            color: #ffffff;
            border: none;
          }
        }

        .bg_gray {
          background: #f7f7f7;
          color: #7a7a7a;
        }
      }
    }
  }
}
</style>